import { useCallback, useContext } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { SingleProductContext } from 'contexts';

import { useOrderModal } from 'hooks';

import { getSearchParams } from 'helpers/getSearchParams';

import { SelectionModal } from 'pages/Catalogue/components/SelectionModal';

import { OrderModal } from 'components/OrderModal';

import { Gallery } from '../Gallery';
import { ProductModal } from '../ProductModal';

export function Modals(): React.ReactElement {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const searchParamsData = getSearchParams(searchParams);

  const {
    isGalleryVisible,
    isProductModalVisible,
    isOrderModalVisible,
    isSelectionModalVisible,
    isOrderModalVisibleSet,
    isSelectionModalVisibleSet,
    galleryUrls,
    image,
    title,
  } = useContext(SingleProductContext);

  const getItemPayload = useCallback(
    () => ({
      productCode: searchParamsData?.itemCode ?? '',
      mainFabricCode: searchParamsData?.mainFabricCode ?? '',
      colorCode: searchParamsData?.colorCode ?? searchParamsData?.itemColorCode ?? '',
      sizes: [],
    }),
    [searchParamsData]
  );

  const onSuccess = useCallback(() => {
    isOrderModalVisibleSet(false);
  }, []);

  const { onOrderSubmit, isOrderLoading } = useOrderModal({ getItemPayload, onSuccess });

  return (
    <>
      {isProductModalVisible && image ? <ProductModal url={image} title={title} /> : null}

      {isGalleryVisible && galleryUrls.length > 0 ? (
        <Gallery galleryUrls={galleryUrls} />
      ) : undefined}

      {isOrderModalVisible ? (
        <OrderModal
          onClose={() => isOrderModalVisibleSet(false)}
          onSubmit={onOrderSubmit}
          isLoading={isOrderLoading}
        />
      ) : undefined}

      {isSelectionModalVisible && id ? (
        <SelectionModal productId={id} onClose={() => isSelectionModalVisibleSet(false)} />
      ) : undefined}
    </>
  );
}
